import Reflux from "reflux";
export const PaymentSelectorActions = {
	ToggleSaveCreditCardPermission: Reflux.createAction(["ToggleSaveCreditCardPermission"]),
	ChangeMainPaymentMethod: Reflux.createAction(["ChangeMainPaymentMethod"]),
	ChangeComplementaryPaymentMethod: Reflux.createAction(["ChangeComplementaryPaymentMethod"]),
	ShowUnavailabilityDialogMetroCreditBlocked: Reflux.createAction(["ShowUnavailabilityDialogMetroCreditBlocked"]),
	CancelUnavailabilityDialog: Reflux.createAction(["CancelUnavailabilityDialog"]),
};
